import { topPlaces, userDetail } from "../../services/auth.service";
import { pointList } from "../../services/myRoute.service";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_TOP_PLACES = "SHOW_TOP_PLACES";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const RESET_DETAIL = "RESET_DETAIL";
export const CURRENT_VIEW = "CURRENT_VIEW";
export const ADDPOINT_NOTIFICATION = "ADDPOINT_NOTIFICATION";
export const BUYPOINT_NOTIFICATION = "BUYPOINT_NOTIFICATION";
export const SHOW_POINT_LIST = "SHOW_POINT_LIST";
export const VIEW_CHECKBOX = "VIEW_CHECKBOX";
// export const CURRENT_DISTANCE = "CURRENT_DISTANCE";

export const showLoader = () => {
    return {
        type: SHOW_LOADER,
    }
}

export const hideLoader = () => {
    return {
        type: HIDE_LOADER,
    }
}

export const showTopPlaces = () => {
    return (dispatch) => {
        topPlaces()
            .then((data) =>
                dispatch({
                    type: SHOW_TOP_PLACES,
                    payload: data?.data,
                },
                )
            )
    }
}

export const getUserDetails = () => {
  return (dispatch) => {
    return userDetail()
      .then((res) => {
        dispatch({
          type: GET_USER_DETAILS,
          payload: res?.data,
        });
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const resetUserDetail = () => {
    return {
        type: RESET_DETAIL,
    }
}

export const changeView = (view) => {
    return (dispatch) => {
        dispatch({
            type: CURRENT_VIEW,
            payload: view
        })
    }
}

// export const changeDistance = (distance) => {
//     return (dispatch) => {
//         dispatch({
//             type: CURRENT_DISTANCE,
//             payload: distance
//         })
//     }
// }

export const addPointNotification = (status) => {
    return {
        type: ADDPOINT_NOTIFICATION,
        payload: status
    }
}

export const buyPointNotification = (status) => {
    return {
        type: BUYPOINT_NOTIFICATION,
        payload: status
    }
}

export const showPointList = () => {
    return (dispatch) => {
        pointList()
            .then((data) =>
                dispatch({
                    type: SHOW_POINT_LIST,
                    payload: data?.data,
                }, dispatch(hideLoader())
                ),
            )
    }
}

export const checkedCheckbox = (status) => {
    return (dispatch) => {
        dispatch({
            type: VIEW_CHECKBOX,
            payload: status
        })
    }
}